import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { Button } from "./ui/button";
import { Trash2, Clock, Car, ArrowRight } from "lucide-react";

export const HistoryDrawer = ({ open, onOpenChange, items, onClear, onReplay }) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        data-testid="search-history-drawer"
        side="right"
        className="w-full border-slate-800 bg-slate-950 text-slate-100 sm:max-w-md"
      >
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2 font-heading text-xl text-slate-50">
            <Clock className="h-5 w-5 text-cyan-400" />
            Historique de recherches
          </SheetTitle>
          <p className="text-sm text-slate-400">
            Vos dernières plaques et pièces consultées (sauvegarde locale, aucun compte).
          </p>
        </SheetHeader>

        <div className="mt-6 space-y-3">
          {items.length === 0 && (
            <div
              data-testid="history-empty"
              className="rounded-xl border border-dashed border-slate-800 p-8 text-center text-sm text-slate-500"
            >
              Aucune recherche enregistrée pour le moment.
            </div>
          )}
          {items.map((item) => (
            <button
              key={item.id}
              data-testid={`history-item-${item.id}`}
              onClick={() => onReplay(item)}
              className="group flex w-full items-start gap-3 rounded-xl border border-slate-800 bg-slate-900/60 p-4 text-left transition hover:border-cyan-500/40 hover:bg-slate-800"
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-cyan-500/15">
                <Car className="h-5 w-5 text-cyan-300" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="rounded bg-slate-100 px-2 py-0.5 font-mono text-xs font-bold text-slate-950">
                    {item.plaque}
                  </span>
                  <span className="truncate text-sm font-semibold text-slate-100">
                    {item.marque} {item.modele}
                  </span>
                </div>
                {item.part_query && (
                  <div className="mt-1 text-xs text-slate-400">
                    Pièce : <span className="text-slate-200">{item.part_query}</span>
                  </div>
                )}
                <div className="mt-1 font-mono text-[10px] uppercase tracking-widest text-slate-500">
                  {new Date(item.created_at).toLocaleString("fr-FR")}
                </div>
              </div>
              <ArrowRight className="h-4 w-4 text-slate-600 transition group-hover:text-cyan-400" />
            </button>
          ))}
        </div>

        {items.length > 0 && (
          <Button
            data-testid="clear-history-button"
            variant="outline"
            onClick={onClear}
            className="mt-6 w-full gap-2 border-red-500/40 bg-red-500/10 text-red-300 hover:bg-red-500/20"
          >
            <Trash2 className="h-4 w-4" />
            Effacer l'historique
          </Button>
        )}
      </SheetContent>
    </Sheet>
  );
};
